export default __webpack_public_path__ + "static/media/Expert.46d493ce.png";